/**
 * Centralized bootstrap reader. Returns the array/object stored in
 * window.__ATC_BOOTSTRAP__ for the given key, or null if not present.
 *
 * This lets every public page render the owner's real CMS data on first
 * paint with zero API calls.
 */
export function getBootstrap(key) {
  if (typeof window === "undefined") return null;
  const boot = window.__ATC_BOOTSTRAP__;
  if (!boot || typeof boot !== "object") return null;
  return boot[key] ?? null;
}
